import {TimeoutExecutorProps} from "../types/timeoutExecutorProps";
import React from "react";

// create a restriction or "branded" type to enforce that only a particular kind of type is allowed
// eg ensures only certain values (between 0 and 1) are accepted
type Opacity = number & { __opacity__: never };

function isOpacity(value: number): value is Opacity {
    return value >= 0 && value <= 1;
}

class GenericHelper {
    static toOpacity(value: number): Opacity {
        const clampedValue = Math.min(1, Math.max(0, value));
        return clampedValue as Opacity;
    };
    
    static hexToRGBA(hex : string, opacity: Opacity) {
        if (!isOpacity(opacity)) {
            throw new Error("Opacity must be between 0 and 1");
        }
        // Remove the hash at the start if it's there
        hex = hex.replace(/^#/, '');

        // Parse r, g, b values
        let r = parseInt(hex.substring(0, 2), 16);
        let g = parseInt(hex.substring(2, 4), 16);
        let b = parseInt(hex.substring(4, 6), 16);

        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }

    static shuffle<T>(array: T[]): T[] {
        if (!Array.isArray(array)) {
            throw new TypeError("The input must be an array");
        }

        if (array.length <= 1) {
            return array;
        }

        // Create a copy to avoid mutating the original array
        const result = [...array];
        
        let maxIndex = result.length;
        let temp;
        let i;

        // Loop until all elements have been shuffled)
        while (maxIndex) {
            // `i` is a random index within the range of 0 to `maxIndex - 1`
            i = Math.floor(Math.random() * maxIndex--);
            
            // Swap the current element at `m` with the element at index `i`
            temp = result[maxIndex];         // Temporarily store the element at index `maxIndex`
            result[maxIndex] = result[i];     // Replace the element at `maxIndex` with the one at `i`
            result[i] = temp;                // Place the stored element at index `i`
        }
        return result;
    }
    
    static executeTimeouts(timeouts: TimeoutExecutorProps[], executedTimeouts: { [key: string]: boolean }, setExecutionTracker: React.Dispatch<React.SetStateAction<{ [key: string]: boolean }>>) {
        
        const nextTimeoutIndex = timeouts.findIndex(t => !executedTimeouts[t.id]);

        if(nextTimeoutIndex < 0) {
            return;
        }

        setTimeout((elementId) => {
            setExecutionTracker(prev => {
                prev[elementId] = true;
                return { ...prev }
            });
        }, timeouts[nextTimeoutIndex].timeout, timeouts[nextTimeoutIndex].id);
    }
}

export {GenericHelper}